import React, { useEffect, useState } from "react";
import CookieIcon from "@mui/icons-material/Cookie";
import { Button } from "../Button/Button";
import * as S from "./Styles";

const CONSENT_STORAGE_KEY = "cookieConsent";
const GOOGLE_ADS_ID = "AW-17925675252";
const GOOGLE_ADS_SCRIPT_ID = "google-ads-script";

interface CookieBannerProps {
  onConsentChange: (hasConsent: boolean) => void;
}

const enableGoogleAdsTracking = () => {
  if (document.getElementById(GOOGLE_ADS_SCRIPT_ID)) {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.gtag = (...args: any[]) => window.dataLayer.push(args);
  window.gtag("js", new Date());
  window.gtag("config", GOOGLE_ADS_ID);

  const script = document.createElement("script");
  script.id = GOOGLE_ADS_SCRIPT_ID;
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ADS_ID}`;
  document.head.appendChild(script);
};

const CookieBanner = ({ onConsentChange }: CookieBannerProps) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_STORAGE_KEY);

    if (consent === "accepted") {
      enableGoogleAdsTracking();
      onConsentChange(true);
      return;
    }

    onConsentChange(false);
    setIsVisible(consent === null);
  }, [onConsentChange]);

  const handleConsent = (hasConsent: boolean) => {
    setIsVisible(false);
    localStorage.setItem(CONSENT_STORAGE_KEY, hasConsent ? "accepted" : "rejected");
    onConsentChange(hasConsent);

    if (hasConsent) {
      enableGoogleAdsTracking();
    }
  };

  if (!isVisible) return null;

  return (
    <S.Container>
      <S.Content>
        <S.TitleContainer>
          <CookieIcon style={{ width: "32px", height: "32px" }} />
          <S.Title>Informasjonskapsler</S.Title>
        </S.TitleContainer>
        <S.Body>
          <S.BodyText>Vi bruker informasjonskapsler for å forbedre brukeropplevelsen.</S.BodyText>
          <S.BodyText>
            Med ditt samtykke samler vi inn data om hvordan du bruker siden, slik at vi kan forbedre den.
          </S.BodyText>
        </S.Body>
        <S.Actions>
          <Button onClick={() => handleConsent(false)} text="Avslå" variant="secondary" />
          <Button onClick={() => handleConsent(true)} text="Godta" />
        </S.Actions>
      </S.Content>
    </S.Container>
  );
};

export default CookieBanner;
